import { computed } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import type { Ref } from 'vue'
import apis from '@/services'

export type RateCheckStatus = 'AVAILABLE' | 'UNAVAILABLE' | 'UNKNOWN'

export interface RateCheckResponse {
  status: RateCheckStatus
  partnerId: number | null
}

export const useRateCheckQuery = (accommodationId: Ref<number | null>) =>
  useQuery({
    queryKey: ['rateCheck', accommodationId],
    queryFn: (): Promise<RateCheckResponse> =>
      apis.rateConnect
        .checkRateAvailability({ accommodationId: String(accommodationId.value) })
        .then(r => r.data),
    enabled: computed(() => !!accommodationId.value),
    staleTime: 0,
    retry: false,
  })
